import { APIError } from './apiError';

class PermissionError extends APIError {}

export { PermissionError };
export default PermissionError;
